module.exports = __webpack_public_path__ + "static/media/bg4-winter.0ce14899.png";